<template>
  <div>
    <transition name="fade" mode="out-in">
      <div key="asd" v-if="isFolderLoading">
        <div class="columns">
          <div class="column">
            <b-skeleton height="200px" :animated="true"></b-skeleton>
          </div>
          <div class="column">
            <b-skeleton height="200px" :animated="true"></b-skeleton>
          </div>
          <div class="column">
            <b-skeleton height="200px" :animated="true"></b-skeleton>
          </div>
          <div class="column">
            <b-skeleton height="200px" :animated="true"></b-skeleton>
          </div>
        </div>
      </div>
      <div key="qwe" v-else>
        <b-button
          type="is-primary is-small"
          rounded
          icon-left="plus"
          @click="openCreateFolders"
          >Crear Carpeta</b-button
        >
        <br /><br />
        <div class="columns is-desktop is-multiline">
          <div class="column is-3">
            <TrashDirectory></TrashDirectory>
          </div>
          <div class="column is-3" v-for="list in listDirectory" :key="list.id">
            <div class="card">
              <header class="card-header">
                <p class="card-header-title">{{ list.name }}</p>
                <b-tooltip v-if="profile != 'functionary'" type="is-light" label="Eliminar carpeta">
                  <a @click="deleteFolder(list.id, list.name)" v-if="list.cantFolders == 0 && list.cantFiles == 0" href="#" class="card-header-icon is-danger">
                   <b-icon
                      pack="fas"
                      icon="trash"
                      size="is-small"
                      type="is-danger">
                  </b-icon>
                </a>
                </b-tooltip>
              </header>
              <div class="card-content">
                <router-link
                  :to="{
                    name: `directory${profile.charAt(0).toUpperCase() + profile.slice(1)}`,
                    params: { id: list.id, name: list.name, cellarId: $route.params.id },
                  }"
                >
                  <div class="content">
                    <div class="columns">
                      <div class="column">
                        <figure class="image is-64x64">
                          <img src="/folder-icon.png" alt="Image" />
                        </figure>
                      </div>
                      <div class="column">
                        <b-icon pack="fas" icon="folder" size="is-small">
                        </b-icon> {{list.cantFolders}} <br>
                         <b-icon pack="fas" icon="file-archive" size="is-small">
                        </b-icon> {{list.cantFiles}}
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
              <footer class="card-footer">
                <a
                  href="#"
                  class="card-footer-item"
                  @click="editOpenFolders(list.id)"
                >
                  Editar</a
                >
                <!-- <a href="#" class="card-footer-item">Eliminar</a> -->
              </footer>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import CreateDirectory from "../../general/directory/CreateDirectory";
import EditDirectory from "../../general/directory/EditDirectory";
import TrashDirectory from "../../../components/administrative/directory/TrashDirectory";
import { DirectoryService } from "../../../services/models/directory";
import { DocumentService } from '../../../services/models/document';
import {eventBus} from "./../../../main";

export default {
  props: ["folder_id"],
  components:{
    TrashDirectory,
  },
  data() {
    return {
      isFolderLoading: true,
      listDirectory: [],
      profile: window.localStorage.getItem("perfil")
    };
  },
  mounted() {
    this.chargeListDirectory();
    eventBus.$on("loadDirectories", () => {
      this.chargeListDirectory();
    });
  },
  watch: {
    folder_id() {
      this.chargeListDirectory();
    },
  },
  methods: {
    async deleteFolder(id, folderName) {
      this.$buefy.dialog.confirm({
        title: "¿Desea eliminar esta carpeta?",
        message:
          `Una vez eliminada la carpeta <b>${folderName}</b> no se podrá recuperar`,
        confirmText: "Eliminar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          this.isFolderLoading = true;
          await DirectoryService.remove(id);
          this.$buefy.notification.open({
            message: `La carpeta fue eliminada con éxito!`,
            type: "is-success",
          });
          this.isFolderLoading = false;
          this.chargeListDirectory();
        },
      });
    },
    openCreateFolders() {
      this.$buefy.modal.open({
        parent: this,
        component: CreateDirectory,
        props: {
          chargeListDirectory: this.chargeListDirectory,
          ...(this.folder_id && { folder_id: this.folder_id }),
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    editOpenFolders(id) {
      this.$buefy.modal.open({
        parent: this,
        component: EditDirectory,
        props: {
          chargeListDirectory: this.chargeListDirectory,
          id: id,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    async chargeListDirectory() {
      this.isFolderLoading = true;
      let directories;
      if (this.folder_id) {
        directories = await DirectoryService.getChildren(this.folder_id);
        console.log(directories);
        directories = directories.data[0].children;
      } else {
        directories = await DirectoryService.getDirectoriesFindByCellar(
          this.$route.params.id
        );
        directories = directories.data;
      }
      let data=[];
      for (let i = 0; i < directories.length; i++) {
        const { data: countFolder } = await DirectoryService.getCountByDependencyId(
          directories[i].id
        );
        const { data: countFile } = await DocumentService.getCountByDirectoryId(
          directories[i].id
        );
        data.push({ ...directories[i], cantFolders: countFolder, cantFiles:countFile });
      }
      this.listDirectory= data;
      this.isFolderLoading = false;
    },
  },
};
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>